import { Target, Handshake, HeartPulse } from "lucide-react";
import { Reveal, Eyebrow } from "../components/site/Reveal";
import { CTABand } from "../components/site/CTABand";
import { PILLARS } from "../lib/content";

const ICONS = [Target, Handshake, HeartPulse];

export default function Approach() {
  return (
    <>
      <section className="relative overflow-hidden border-b border-slate-200">
        <div className="absolute inset-0 grid-bg" aria-hidden="true" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-10 py-20 lg:py-28">
          <Reveal>
            <Eyebrow testId="approach-eyebrow">A recruitment partner for your workforce</Eyebrow>
            <h1 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-[#0A1F44] max-w-3xl leading-[1.08]">
              Permanent talent. Contract expertise.{" "}
              <span className="text-blue-700">Ongoing support.</span>
            </h1>
            <p className="mt-7 text-slate-600 text-base md:text-lg leading-relaxed max-w-2xl">
              For over 10 years, BMP Tech One Pty Ltd has supported organisations across retail,
              government, not-for-profit, utilities, banking & insurance and education with
              specialist recruitment and contingent workforce placements, backed by local account
              management from our Sydney headquarters.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
        <div className="grid md:grid-cols-3 gap-6">
          {PILLARS.map((p, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={p.title} delay={i * 0.12}>
                <div
                  data-testid={`approach-pillar-${i}`}
                  className="h-full rounded-2xl border border-slate-200 bg-white p-8 transition-all duration-300 hover:border-blue-600/50 hover:-translate-y-1"
                >
                  <div className="flex h-14 w-14 items-center justify-center rounded-xl bg-blue-700/10 text-blue-700">
                    <Icon className="h-6 w-6" />
                  </div>
                  <h2 className="mt-6 font-display text-xl font-bold text-[#0A1F44] tracking-tight">{p.title}</h2>
                  <p className="mt-4 text-slate-600 leading-relaxed text-sm">{p.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>

        <Reveal className="mt-16">
          <div className="rounded-2xl border border-amber-400/60 bg-amber-50 p-8 md:p-10" data-testid="approach-whs-note">
            <p className="font-mono text-xs uppercase tracking-[0.22em] text-blue-700">WHS framework</p>
            <p className="mt-4 text-slate-700 leading-relaxed max-w-3xl">
              Worker safety sits at the centre of every placement. Pre-placement assessment, inductions,
              scheduled worker check-ins, incident reporting and ongoing consultation with host
              organisations are built into how we manage every engagement.
            </p>
          </div>
        </Reveal>
      </section>

      <CTABand />
    </>
  );
}
